module.exports = new __parcel__URL__("../images/cracs.a5eaddb5.png").toString();